import {
  ComplianceGeoLocationClient,
  IpLocationData,
  RestrictedLocationData,
  UserLocationData,
  UserLocationDto,
} from "@nestcoinco/hyper-api-gateway-api-client";

import apiConfig from "../config/api-config";
import { axiosInstance } from "../config/axios-instance";

const complianceGeoLocationClient = new ComplianceGeoLocationClient(
  apiConfig,
  undefined,
  axiosInstance
);

const getIpLocationData = async (): Promise<IpLocationData | undefined> => {
  try {
    const ipLocationData = (
      await complianceGeoLocationClient.getUserGeoLocationFromIp()
    ).data;
    return ipLocationData;
  } catch {
    return;
  }
};

const getRestrictedLocations = async (): Promise<
  RestrictedLocationData[] | undefined
> => {
  try {
    const restrictedLocations = (
      await complianceGeoLocationClient.fetchRestrictedLocations()
    ).data.records;
    return restrictedLocations;
  } catch {
    return;
  }
};

const storeLocationData = async (
  userLocationInfo: UserLocationDto
): Promise<UserLocationData | undefined> => {
  try {
    const userLocationData = (
      await complianceGeoLocationClient.storeUserLocation(userLocationInfo)
    ).data;
    return userLocationData;
  } catch {
    return;
  }
};

export { getIpLocationData, getRestrictedLocations, storeLocationData };
